module.exports = __webpack_public_path__ + "img/credit-card-bg-circle.48fe07a0.svg";